/**
 * Project: Aniatek
 * Author: Carlos A. Loaiza | Connect & Launch
 * Tel: +52 (667) 247 - 6316
 * Intellectual Property: All rights reserved (c) 2026
 */
 
 <template>
    <div class="noti-card view-card">
        <section class="informacion2">
            <h2 class="section-subtitle">Notificaciones Recientes</h2>
            <section v-for="(notificacion, index) in notificacion" :key="index" class="notification-item">
                <div class="notification-content">
                    <div class="notification-icon-container">
                        <i class="fa-solid fa-bell"></i>
                    </div>
                    <div class="notification-info">
                        <div class="notification-title">Notificación</div>
                        <div>{{ notificacion.mensaje }}</div>
                    </div>
                    <div class="notification-close" @click="$emit('eliminar-notificacion', index)">
                        <div>X</div>
                    </div>
                </div>
            </section>
            <div v-if="notificacion.length === 0" class="no-notifications">
                Próximamente.
            </div>
        </section>
    </div>
</template>

<script>
export default {
    props: ['notificacion'], 
};
</script>

<style scoped>
.section-subtitle {
    font-size: 18px;
    font-weight: 600;
    margin-top: 0;
    margin-bottom: 20px;
    color: #333;
}

.no-notifications {
    padding: 15px;
    background-color: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    text-align: center;
    font-size: 18px;
    font-weight: 600;
    margin-top: 0;
    margin-bottom: 20px;
    color: #29b9f6;
}

.notification-item {
    border: 1px solid #eee;
    border-radius: 6px;
    margin-bottom: 10px;
    transition: box-shadow 0.2s;
}

.notification-item:hover {
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
}

.notification-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
}

.notification-icon-container {
    color: #4652e8;
    font-size: 18px;
    margin-right: 10px;
}

.notification-info {
    flex-grow: 1;
}

.notification-title {
    font-weight: 600;
    font-size: 14px;
}

.notification-close {
    cursor: pointer;
    font-weight: bold;
    color: #dc3545;
    padding: 5px;
    margin-left: 15px;
}
</style>